import { inject, Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MatDateLocaleSyncService {
  private dateAdapter = inject(DateAdapter<Date>);
  private translate = inject(TranslateService);

  constructor() {
    this.dateAdapter.setLocale(this.translate.currentLang || 'hu');
    this.translate.onLangChange.subscribe(event => {
      this.dateAdapter.setLocale(event.lang);
    });
  }
}
